import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { RightWidgetComponent } from "./right-widget/right-widget.component";
import { HomePageComponent } from "./home-page/home-page.component";
import { RegistrationComponent } from "./registration/registration.component";
import { ContractComponent } from "./contract/contract.component";
import { WelcomeComponent } from "./welcome/welcome.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PhoneMaskDirective } from "./phone-mask.directive";
import { TextMaskModule } from "angular2-text-mask";
import { RouterModule, Routes } from "@angular/router";
import { TooltipDirective } from "./tooltip.directive";
import { PopoverModule } from "ngx-smart-popover";
import { LightboxModule } from "ngx-lightbox";
import { Registration1Component } from "./registration1/registration1.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { HashLocationStrategy, LocationStrategy } from "@angular/common";
import { TokenLogService } from "./_services/tokenLogService";
import { XrmService } from "./_services/xrmService";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ErrorComponent } from "./error/error.component";
import { AppConfigService } from "./_services/appConfigService";
import { SessionTimeOutComponent } from "./session-time-out/session-time-out.component";
import { AppfolioRegistrationComponent } from "./appfolio/registration/appfolio-registration.component";
import { AppFolioWelcomeComponent } from "./appfolio/welcome/appfolio-welcome.component";
import { AppFolioService } from "./_services/appfolioService";
import { AppfolioContractComponent } from "./appfolio/contract/appfolio-contract.component";
import { AppFolioHomePage } from "./appfolio/home-page/appfolio-home-page.component";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    RightWidgetComponent,
    HomePageComponent,
    RegistrationComponent,
    ContractComponent,
    WelcomeComponent,
    PhoneMaskDirective,
    TooltipDirective,
    Registration1Component,
    ErrorComponent,
    SessionTimeOutComponent,
    AppfolioRegistrationComponent,
    AppFolioWelcomeComponent,
    AppfolioContractComponent,
    AppFolioHomePage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TextMaskModule,
    LightboxModule,
    NgxSpinnerModule,
    PopoverModule,
    NgbModule,
  ],
  providers: [
    TokenLogService,
    XrmService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      },
    },
    AppFolioService,
  ],
  bootstrap: [AppComponent],
  exports: [NgxSpinnerModule],
})
export class AppModule {}
